/**
 * Register theme components
 */
import { App } from 'vue';

import LayoutBox from './Layouts/Partials/LayoutBox.vue';
import LayoutBoxSidebar from './Layouts/Partials/LayoutBoxSidebar.vue';
import LayoutContainer from './Layouts/Partials/LayoutContainer.vue';

export const useComponents = (app: App<Element>): void => {
    app.component('LayoutBox', LayoutBox);
    app.component('LayoutBoxSidebar', LayoutBoxSidebar);
    app.component('LayoutContainer', LayoutContainer);

    useStyleDirectives(app);
};

export const useStyleDirectives = (app: App<Element>): void => {
    /**
     * Theme style directives
     */
    app.directive('input-group', {
        mounted(el: HTMLElement) {
            el.classList.add(
                'absolute',
                'inset-y-0',
                'right-0',
                'z-10',
                'cursor-pointer',
                'border',
                'border-[color:var(--color-border-default)]',
                'bg-[color:var(--color-input-bg)]',
                'hover:bg-[color:var(--color-surface-02)]',
                'focus:bg-[color:var(--color-surface-02)]',
                'focus:ring-0',
                'focus:border-[color:var(--color-border-default)]',
            );
        },
    });

    app.directive('input-group-wrapper', {
        mounted(el: HTMLElement) {
            el.classList.add('absolute', 'inset-y-0', 'right-0', 'z-10');
        },
    });
};
